import { jsx as _jsx } from "react/jsx-runtime";
import { useClassName } from '../../../../hooks';
export const Option = (props) => {
    const className = useClassName({ name: 'select-option', prefixed: true });
    return _jsx("option", { ...props, className: className });
};
